// 首頁「03 · 2025 年度回顧」的小工具（2026-10-04）：導言裡的件數（{performance}、{teaching}⋯）由 src/data/home-2025.json 各組的 items 數填，
// 清單加減一筆，導言跟著變，不會出現「四項教學」但清單只有三項。中文用「兩」不用「二」（兩檔、兩項）。
const ZH = ['零', '一', '兩', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五']
const EN = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen']

export const countWord = (n, lang) => (lang === 'zh' ? ZH : EN)[n] ?? String(n)

export function fillCounts (data, lang) {
  const counts = Object.fromEntries((data?.groups || []).map(g => [g.key, g.items.length]))
  return String(data?.intro?.[lang] || '').replace(/\{(\w+)\}/g, (m, key) => (key in counts ? countWord(counts[key], lang) : m))
}
